import HeatMapBlock from './HeatMapBlock';

export default HeatMapBlock;
